import { defineMessages } from 'react-intl';

export default defineMessages({
    paymentComponentBuyNow: {
        id: 'portal.payment.integration.quoteandbind.directives.custom-quote.BOP.BuyNow',
        defaultMessage: 'BuyNow'
    },
    paymentSource: {
        id: 'portal.payment.amp.bc3.directives.templates.payment-instrument-bc3.Source',
        defaultMessage: 'Source'
    },
    bankAccountSource: {
        id: 'portal.payment.amp.bc3.directives.templates.payment-instrument-bc3.Bank Account',
        defaultMessage: 'Bank Account'
    },
    cardIssuer: {
        id: 'portal.payment.platform.paymentdetails.credit-card-auto-details.Card Issuer',
        defaultMessage: 'Card Issuer',
    },
    selectIssuer: {
        id: 'portal.payment.platform.paymentdetails.credit-card-auto-details.-- Please Select --',
        defaultMessage: '-- Please Select --'
    },
    paymentMethod: {
        id: 'portal.payment.quoteandbind.views.payment-details.Payment Method',
        defaultMessage: 'Set Payment Source',
    },
    bankAccount: {
        id: 'portal.payment.quoteandbind.views.payment-details.Bank Account',
        defaultMessage: 'Bank Account',
    },
    creditCard: {
        id: 'portal.payment.quoteandbind.views.payment-details.Credit Card',
        defaultMessage: 'Credit Card',
    },
    accountType: {
        id: 'portal.payment.quoteandbind.directives.templates.bank-account-details-quote.Account Type',
        defaultMessage: 'Account Type',
    },
    howToPay: {
        id: 'portal.payment.quoteandbind.directives.templates.bank-account-details-quote.How do you want to pay?',
        defaultMessage: 'How do you want to pay?',
    },
    accountNumber: {
        id: 'portal.payment.quoteandbind.directives.templates.bank-account-details-quote.Account Number',
        defaultMessage: 'Account Number',
    },
    routingNumber: {
        id: 'portal.payment.quoteandbind.directives.templates.bank-account-details-quote.Routing (ABA) Number',
        defaultMessage: 'Routing (ABA) Number',
    },
    bankName: {
        id: 'portal.payment.quoteandbind.directives.templates.bank-account-details-quote.Bank Name',
        defaultMessage: 'Bank Name',
    },
    cancel: {
        id: 'portal.payment.platform.paymentdetails.Cancel',
        defaultMessage: 'Cancel',
    },
    checkbox: {
        id: 'portal.payment.platform.paymentdetails.agree',
        defaultMessage: 'I agree to the {terms}',
    },
    termandConditionsheader:{
        id:'portal.payment.platform.paymentdetails.Terms and Conditions',
        defaultMessage:'Terms and Conditions'
    },
    termsandConditionsText1:{
        id:'portal.payment.platform.terms and conditions text 1',
        defaultMessage:'I authorize CopperPoint Insurance Company (“CopperPoint”) to debit the bank account indicated in this web form for the noted amount on today\'s date for payment of premium to CopperPoint on the account referenced above. This authorization applies to payment of premium on the account referenced above and to any credit entries to the account to correct any erroneous deductions or to provide a refund of premium.'
    },
    termsandConditionsText2:{
        id:'portal.payment.platform.terms and conditions text 2',
        defaultMessage:'I understand that because this is an electronic transaction, these funds may be withdrawn from my account as soon as the above noted transaction date. In the case of an EFT/ACH Transaction being rejected Non-Sufficient Funds (NSF), I understand that CopperPoint may, in its discretion, attempt to process the charge again within 30 days. I understand that an EFT/ACH Transaction rejected for Non-Sufficient Funds (NSF) may result in cancellation or non-renewal of my policy.'
    },
    termsandConditionsText3:{
        id:'portal.payment.platform.terms and conditions text 3',
        defaultMessage:'I certify that I am an authorized user of this bank account, and that I will not dispute the payment with my Bank so long as the transaction corresponds to the terms indicated in this web form.'
    },
    termsandConditionsText4:{
        id:'portal.payment.platform.terms and conditions text 4',
        defaultMessage:'I authorize the financial institution identified by the routing number above to accept and post entries to the account.'
    },
    termsandConditionsText5:{
        id:'portal.payment.platform.terms and conditions text 5',
        defaultMessage:'I have read and agree to all of the CopperPoint terms and conditions.'
    }
});
